import { useIsTradeInfoLoaded } from '~/contexts/FinanceAndTradeContext';
import { useIsUserLoaded, useIsUserLoggedIn } from '~/contexts/UserContext';

export default function useShouldFetchInventory() {
  const tradeIsLoaded = useIsTradeInfoLoaded();
  const userIsLoaded = useIsUserLoaded();
  const userIsLoggedIn = useIsUserLoggedIn();

  return !userIsLoggedIn || (userIsLoaded && tradeIsLoaded);
}
